import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { Survey } from '../../types/domainModels';
import { clsx } from 'clsx';
import AdminEventLog from './AdminEventLog';
import { useHasRole } from 'hooks/users';

interface AdminStepProps {
  survey: Survey;
}

const AdminStep = ({ survey }: AdminStepProps) => {
  const isAdmin = useHasRole('admin');
  const navigate = useNavigate();
  const { id: surveyId, resourceId } = useParams<{
    id: string;
    resourceId?: string;
  }>();

  if (!isAdmin) {
    return <Navigate replace to={'/'} />;
  }

  // Default to event-log if no resourceId is provided
  const currentTab = resourceId || 'event-log';

  // If no subroute is specified, redirect to event-log
  if (!resourceId) {
    return (
      <Navigate replace to={`/surveys/${surveyId}/build/admin/event-log`} />
    );
  }

  const handleTabClick = (tab: string) => {
    navigate(`/surveys/${surveyId}/build/admin/${tab}`);
  };

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-gray-900 mb-2">
          Admin Settings
        </h1>
        <p className="text-gray-600">
          Administrative controls and settings for survey {survey.title}
        </p>
      </div>

      {/* Navigation tabs */}
      <div className="border-b border-gray-200 mb-6">
        <nav className="-mb-px flex space-x-8">
          <button
            className={clsx(
              'py-2 px-1 border-b-2 font-medium text-sm',
              currentTab === 'event-log'
                ? 'border-primary-d-500 text-primary-d-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
            )}
            onClick={() => handleTabClick('event-log')}
          >
            Event Log
          </button>
        </nav>
      </div>

      {/* Content area */}
      <div className="mt-6">
        {currentTab === 'event-log' && <AdminEventLog surveyId={survey.id} />}
      </div>
    </div>
  );
};

export default AdminStep;
